import React, { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import AddCommentsToUploadedFilesForm from './AddCommentsToUploadedFilesForm'

import useManageFormsDrawer from '../../../../hooks/formHooks/useManageFormsDrawer'

import { createJsonFromQueryString } from '../../../../helpers/url'

import { getBookedMediaService } from '../../../../modules/services/mediaOrdersBookings'
import { ADD_COMMENTS_TO_UPLOADED_FILES } from '../../../../constants/forms'

function AddCommentsToUploadedFiles() {
  const { mediaId: selectedBookedMediaId } = createJsonFromQueryString(window.location.search)

  const { selectedEditItemId } = useManageFormsDrawer({
    formName: ADD_COMMENTS_TO_UPLOADED_FILES
  })
  const selectedFileId = Number(selectedEditItemId)

  const { data: bookedMediaData, isLoading: getBookedMediaIsLoading } = useQuery({
    queryKey: ['bookedMedia', selectedBookedMediaId],
    queryFn: async () => getBookedMediaService({ id: selectedBookedMediaId }),
    enabled: !!selectedBookedMediaId,
    retry: false
  })

  const isFormLoading = useMemo(
    () => !bookedMediaData || getBookedMediaIsLoading,
    [bookedMediaData, getBookedMediaIsLoading]
  )

  return (
    <FormDrawerWrapper
      formName={ADD_COMMENTS_TO_UPLOADED_FILES}
      showOpenButton={false}
      hasDefaultDrawerContentSpacing={false}
      isWideDrawer
      isFormLoading={isFormLoading}
    >
      <AddCommentsToUploadedFilesForm selectedFileMediaData={bookedMediaData} selectedFileId={selectedFileId} />
    </FormDrawerWrapper>
  )
}

export default AddCommentsToUploadedFiles
